import CommonLayout from "../CommonLayout";

import Footer from "../../../components/Footer";
import Buttons from "./components/Buttons";
import Filters from "./components/Filters";
import Table from "./components/Table";

import { CUSTOMER_TABLE_COLUMNS } from "../../../config/tables";
import { useFetchCustomers } from "./hooks/useFetchCustomers";
import { FiltersType } from "./types/filters.type";
import { usePermissions } from "@/hooks/usePermissions";
import { useTableFiltersCursor } from "../../../hooks/useTableFiltersCursor";

const TABLE_KEY = "customers";

const CustomersContainer = () => {
  const { isEditor } = usePermissions();
  const { queryFilters, setQueryFilters, cursor, setCursor } =
    useTableFiltersCursor<FiltersType>(TABLE_KEY);
  const { customers, nextCursor, isLoading, refetch } = useFetchCustomers(
    queryFilters,
    cursor
  );

  const filters = (
    <Filters queryFilters={queryFilters} setQueryFilters={setQueryFilters} />
  );
  const buttons = isEditor ? <Buttons refetch={refetch!} /> : <></>;
  const table = (
    <Table customers={customers} isLoading={isLoading} refetch={refetch!} />
  );
  const footer = (
    <Footer
      tableProps={{
        fileName: "clientes",
        items: customers,
        columns: CUSTOMER_TABLE_COLUMNS,
        pagination: { tableKey: TABLE_KEY, nextCursor, setCursor, cursor },
      }}
    />
  );

  return CommonLayout({
    title: "Clientes",
    subtitle: "Administra la información de tus clientes",
    filters,
    buttons,
    table,
    footer,
  });
};

export default CustomersContainer;
